import React from "react";
import { ChevronRight } from "lucide-react";

const TILES = [
  { key: "users", label: "NUTZER", stat: "total_users", sub: (s) => `${s?.licensed_users ?? 0} freigeschaltet` },
  { key: "codes", label: "CODES", stat: "total_codes", sub: (s) => `${s?.active_codes ?? 0} aktiv` },
];

export function AdminStatTiles({ stats, active, onSelect }) {
  return (
    <div className="adm-tiles adm-tiles-2" data-testid="admin-stat-tiles">
      {TILES.map((t) => (
        <button key={t.key} type="button" data-testid={`admin-tile-${t.key}`} onClick={() => onSelect(active === t.key ? null : t.key)}
          className={`adm-tile ${active === t.key ? "is-active" : ""}`} aria-pressed={active === t.key}>
          <span className="adm-tile-value" data-testid={`admin-tile-${t.key}-value`}>{stats?.[t.stat] ?? "–"}</span>
          <span className="adm-tile-label">{t.label} <ChevronRight className="h-3.5 w-3.5" /></span>
          <span className="adm-muted" data-testid={`admin-tile-${t.key}-sub`}>{t.sub(stats)}</span>
        </button>
      ))}
    </div>
  );
}
